/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SSEEventDto
 */
export interface SSEEventDto {
    /**
     * Event type indicating the stage of the response stream
     * @type {string}
     * @memberof SSEEventDto
     */
    type: SSEEventDtoTypeEnum;
    /**
     * Content chunk from Gemini (only present in chunk events)
     * @type {string}
     * @memberof SSEEventDto
     */
    data?: string;
    /**
     * UUID of the conversation (present in start, conversation_id, and end events)
     * @type {string}
     * @memberof SSEEventDto
     */
    conversationId?: string;
    /**
     * Error message (only present in error events)
     * @type {string}
     * @memberof SSEEventDto
     */
    error?: string;
    /**
     * ISO timestamp of when the event was generated
     * @type {string}
     * @memberof SSEEventDto
     */
    timestamp: string;
}


/**
 * @export
 */
export const SSEEventDtoTypeEnum = {
    Start: 'start',
    ConversationId: 'conversation_id',
    Chunk: 'chunk',
    End: 'end',
    Error: 'error'
} as const;
export type SSEEventDtoTypeEnum = typeof SSEEventDtoTypeEnum[keyof typeof SSEEventDtoTypeEnum];


/**
 * Check if a given object implements the SSEEventDto interface.
 */
export function instanceOfSSEEventDto(value: object): value is SSEEventDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    return true;
}

export function SSEEventDtoFromJSON(json: any): SSEEventDto {
    return SSEEventDtoFromJSONTyped(json, false);
}

export function SSEEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSEEventDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'data': json['data'] == null ? undefined : json['data'],
        'conversationId': json['conversationId'] == null ? undefined : json['conversationId'],
        'error': json['error'] == null ? undefined : json['error'],
        'timestamp': json['timestamp'],
    };
}

export function SSEEventDtoToJSON(json: any): SSEEventDto {
    return SSEEventDtoToJSONTyped(json, false);
}

export function SSEEventDtoToJSONTyped(value?: SSEEventDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'data': value['data'],
        'conversationId': value['conversationId'],
        'error': value['error'],
        'timestamp': value['timestamp'],
    };
}

